<template>
  <div class="acomodar">
    <Selecciones />

    <!-- Contenedor para la web de Ticka cuando plataformaEscogida sea 12 -->
    <div v-if="plataformaEscogida == '12'" class="container mt-4">
      <div class="card shadow-sm border-0 bg-light p-5 text-center">
        <!-- Estado: Cargando/Sincronizando -->
        <div v-if="!ssoTickaUrl">
          <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status"></div>
          <h4 class="mt-4 fw-bold text-secondary">
            Sincronizando credenciales de acceso...
          </h4>
          <p class="text-muted">
            Estamos preparando su sesión segura en la Mesa de Ayuda.
          </p>
        </div>

        <!-- Estado: Listo para abrir -->
        <div v-else class="fade-in">
          <i class="bi bi-shield-lock-fill text-success display-1"></i>
          <h2 class="mt-3 fw-bold">¡Acceso Autorizado!</h2>
          <p class="text-muted mb-4">
            La plataforma de Tickets se abrirá en una ventana independiente para
            garantizar su seguridad.
          </p>
          <button
            class="btn btn-primary btn-lg px-5 py-3 shadow-lg"
            @click="handleRedirect"
          >
            <i class="bi bi-box-arrow-up-right me-2"></i> INGRESAR A MESA DE AYUDA 
            <span v-if="countdown > 0">({{ countdown }})</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Contenido de gráficos, solo si NO es la plataforma 12 y el permiso es 6 -->
    <div v-else-if="permisoVisualizador == 6">
      <div class="header-titulo">
        <h2>INDICADORES DE GESTION DE CONTRATOS</h2>
      </div>

      <!-- Primera fila: Gráfico 1 y 10 -->
      <div class="row mx-2 fade-in">
        <div class="col-md-7">
          <div class="grafico-container border border-1 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle1 }}</label>
            <div class="d-flex justify-content-center">
              <div class="wide-Bar-container">
                <Bar v-if="loadChartData1" :options="chartOptions1" :data="chartData1" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="grafico-container border border-1 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle10 }}</label>
            <div class="mall-Bar-container">
              <Bar v-if="chartData10 && chartOptions10" :data="chartData10" :options="chartOptions10" />
            </div>
          </div>
        </div>
      </div>

      <!-- Segunda fila: Gráfico 2 y 3 -->
      <div class="row mx-2 fade-in">
        <div class="col-md-7">
          <div class="grafico-container border border-1 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle2 }}</label>
            <div class="d-flex justify-content-center">
              <div class="tall-Bar-container">
                <Bar v-if="loadChartData2" :data="chartData2" :options="chartOptions2" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="grafico-container border border-1 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle3 }}</label>
            <div class="d-flex justify-content-center">
              <div class="Bar-container">
                <Bar v-if="loadChartData3" :data="chartData3" :options="chartOptions3" />
              </div>
            </div>
          </div>
        </div>

        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle11 }}</label>
            <div class="stacked-bar-container">
              <Bar v-if="chartData11 && chartOptions11" :data="chartData11" :options="chartOptions11" />
            </div>
          </div>
        </div>
      </div>

      <!-- SECCIÓN: INDICADORES DE RENOVACIONES -->
      <div class="header-titulo">
        <h2>INDICADORES DE RENOVACIONES</h2>
      </div>
      <div class="grafico-linea-wrapper">
        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle4 }}</label>
            <div class="sll-Bar-container">
              <Bar v-if="loadChartData4" :data="chartData4" :options="chartOptions4" />
            </div>
          </div>
        </div>

        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle5 }}</label>
            <div class="stacked-bar-container">
              <Bar v-if="chartData5 && chartOptions5" :data="chartData5" :options="chartOptions5" />
            </div>
          </div>
        </div>

        <div class="grafico-container-linea">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle6 }}</label>
            <div class="line-chart-container">
              <LineChart v-if="chartData6 && chartOptions6" :data="chartData6" :options="chartOptions6" />
            </div>
          </div>
        </div>
      </div>

      <!-- SECCIÓN: INDICADORES DE CESES DE PERSONAL -->
      <div class="header-titulo">
        <h2>INDICADORES DE CESES DEL PERSONAL</h2>
      </div>
      <div class="graficos-wrapper">
        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle7 }}</label>
            <div class="small-Bar-container">
              <Bar v-if="chartData7 && chartOptions7" :data="chartData7" :options="chartOptions7" />
            </div>
          </div>
        </div>

        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle12 }}</label>
            <div class="small-Bar-container">
              <Bar v-if="chartData12 && chartOptions12" :data="chartData12" :options="chartOptions12" />
            </div>
          </div>
        </div>

        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle8 }}</label>
            <div class="line-chart-container">
              <LineChart v-if="chartData8 && chartOptions8" :data="chartData8" :options="chartOptions8" />
            </div>
          </div>
        </div>

        <div class="grafico-container">
          <div class="row border border-1 mx-2 mt-2 pt-2 pb-2">
            <label class="titulo-grafico">{{ chartTitle9 }}</label>
            <div class="small-Bar-container">
              <Doughnut v-if="chartData9 && chartOptions9" :data="chartData9" :options="chartOptions9" />
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de navegación -->
      <div class="graficos-wrapper">
        <div>
          <button class="btn btn-outline-primary d-flex flex-column align-items-center p-3 rounded-3 mb-3"
            @click="$router.push(`/PreFContrato`)">
            <img src="@/assets/preguntas.png" alt="FAQ Icon" class="mb-2" style="width: 90px; height: 70px" />
          </button>
        </div>
        <div>
          <button class="btn btn-outline-primary d-flex flex-column align-items-center p-3 rounded-3 mb-3"
            @click="$router.push(`/ManualInstructivo`)">
            <img src="@/assets/crud.png" alt="Manual Icon" class="mb-2" style="width: 90px; height: 70px" />
          </button>
        </div>
        <div>
          <button class="btn btn-outline-primary d-flex flex-column align-items-center p-3 rounded-3"
            @click="$router.push(`/Videos`)">
            <img src="@/assets/videos.png" alt="Videos Icon" class="mb-2" style="width: 90px; height: 70px" />
          </button>
        </div>
      </div>
    </div>
    <!-- Título centrado -->
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import Selecciones from "@/components/ModSeleccion/Inicio/Seleccion.vue";
import { Bar, Line as LineChart, Doughnut } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LineElement,
  LinearScale,
  PointElement,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

export default {
  name: "SolimanoextranetBienvenido",
  components: {
    Bar,
    LineChart,
    Selecciones,
    Doughnut,
  },

  data() {
    return {
      loadChartData1: false,
      plataformaEscogida: "",
      // Ahora apuntamos a NUESTRA propia API de .NET
      tickaSyncApiUrl: "Autentication/SyncTickaUser",
      tickaSsoLinkApiUrl: "Autentication/GetTickaSsoLink", // Nueva URL para obtener el link de SSO
      tickaAppBaseUrl: "https://www.solimano.com.pe/ticka/", // URL base de la aplicación Ticka
      // Placeholder para datos de usuario para la sincronización con Ticka
      tickaUserEmail: "",
      tickaUserName: "",
      tickaFullName: "",
      ssoTickaUrl: "", // Almacenará la URL segura devuelta por el backend
      permisoVisualizador: "",
      countdown: 3,
      countdownTimer: null,
      // Gráfico 1: Ingresos a Planilla (Sin cambios)
      chartTitle1: "CANTIDAD DE INGRESOS A PLANILLA DE MANERA MENSUAL",
      chartData1: {
        labels: [],
        datasets: [
          {
            label: "Ingresos Mensuales ",
            backgroundColor: "rgb(255, 165, 0)", // Amarillo
            borderColor: "rgb(255, 165, 0)",
            borderWidth: 1,
            data: [],
          },
        ],
      },
      chartOptions1: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },
      chartTitle10: "CANTIDAD DE INGRESOS A PLANILLA DE MANERA ANUAL",
      chartData10: {
        labels: ["2021", "2022", "2023", "2024", "2025"],
        datasets: [
          {
            label: "Ingresos Anuales",
            backgroundColor: "rgb(238, 130, 238)", // Morado
            borderColor: "rgb(238, 130, 238)",
            borderWidth: 1,
            data: [40, 60, 30, 50, 150],
          },
        ],
      },

      chartOptions10: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },
      loadChartData2: false,
      // Gráfico 2: Barras Horizontales (Centro)
      chartTitle2: "CANTIDAD DE PERSONAL POR DEPARTAMENTO",
      chartData2: {
        labels: [],
        datasets: [
          {
            label: "Personal",
            backgroundColor: "rgba(255, 159, 64, 0.6)", // Naranja
            borderColor: "rgba(255, 159, 64, 1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },
      chartOptions2: {
        indexAxis: "y", // Gráfico horizontal
        responsive: true,
        maintainAspectRatio: false,
      },

      loadChartData3: false,
      // Gráfico 3: Pastel o Barras Apiladas (Derecha)
      chartTitle3: "CANTIDAD DE PERSONAL NACIONAL Y EXTRANJERO POR PLANILLA",
      chartData3: {
        labels: [],
        datasets: [
          {
            label: "Personal",
            backgroundColor: [
              "rgba(75, 192, 192, 0.6)",
              "rgba(255, 99, 132, 0.6)",
            ], // Verde y Rojo
            borderColor: ["rgba(75, 192, 192, 1)", "rgba(255, 99, 132, 1)"],
            borderWidth: 1,
            data: [],
          },
        ],
      },
      chartOptions3: {
        responsive: true,
        maintainAspectRatio: false,
      },
      loadChartData4: false,
      // Gráfico de Líneas (izquierda)
      chartTitle4: "CANTIDAD TOTAL DE RENOVACIONES Y NO RENOVADOS",
      chartData4: {
        labels: [],
        datasets: [
          {
            label: "Personas",
            backgroundColor: [
              "rgba(75, 192, 192, 0.6)",
              "rgba(255, 99, 132, 0.6)",
            ], // Verde y Rojo
            borderColor: ["rgba(75, 192, 192, 1)", "rgba(255, 99, 132, 1)"],
            borderWidth: 1,
            data: [],
          },
        ],
      },
      chartOptions4: {
        responsive: true,
        maintainAspectRatio: false,
      },

      chartTitle11: "INDICE DE DESISTIMIENTO DE CONTRATACION",
      chartData11: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
        datasets: [
          {
            label: "CONTRATADOS",
            backgroundColor: "rgba(54, 162, 235, 0.6)", // Azul
            data: [10, 55, 12, 20, 18],
          },
          {
            label: "DESISTEN",
            backgroundColor: "rgba(255, 99, 132, 0.6)", // Rojo
            data: [50, 40, 53, 30, 58],
          },
        ],
      },
      chartOptions11: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },
      // Gráfico de Barras Apiladas (Centro)
      chartTitle5: "PROCESO DE RENOVACION PI, PO y TALSI",
      chartData5: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
        datasets: [
          {
            label: "PI",
            backgroundColor: "rgba(54, 162, 235, 0.6)", // Azul
            data: [30, 40, 50, 60, 70],
          },
          {
            label: "PO",
            backgroundColor: "rgba(255, 99, 132, 0.6)", // Rojo
            data: [20, 30, 40, 50, 60],
          },
          {
            label: "TALSI",
            backgroundColor: "rgba(255, 206, 86, 0.6)", // Amarillo
            data: [10, 20, 30, 40, 50],
          },
        ],
      },
      chartOptions5: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true },
        },
        scales: {
          x: { stacked: true },
          y: { stacked: true, beginAtZero: true },
        },
      },

      // Nuevo Gráfico de Líneas (Derecha)
      chartTitle6: "Evolución mensual de renovaciones",
      chartData6: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
        datasets: [
          {
            label: "Renovaciones",
            data: [20, 50, 10, 40, 30],
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            tension: 0.4,
            fill: true,
          },
          {
            label: "No Renovados",
            data: [60, 50, 20, 55, 10],
            borderColor: "rgba(255, 99, 132, 1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            tension: 0.4,
            fill: true,
          },
        ],
      },
      chartOptions6: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },

      // Gráfico 1: Número de ceses mensual y anual (Izquierda)
      chartTitle7: "CANTIDAD DE CESES DE FORMA MENSUAL ",
      chartData7: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
        datasets: [
          {
            label: "Personas",
            backgroundColor: "rgba(54, 162, 235, 0.6)", // Azul
            data: [10, 15, 12, 26, 18],
          },
        ],
      },
      chartOptions7: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },

      chartTitle12: "CANTIDAD DE CESES DE FORMA ANUAL",
      chartData12: {
        labels: ["2021", "2022", "2023", "2024", "2025"],
        datasets: [
          {
            label: "Personas",
            backgroundColor: "rgba(54, 162, 235, 0.6)", // Azul
            data: [10, 15, 12, 26, 18],
          },
        ],
      },
      chartOptions12: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },

      // Gráfico 2: Tasa de rotación (Centro)
      chartTitle8: "TASA DE ROTACION DE EMPLEADOS QUE DEJAN LA EMPRESA",
      chartData8: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
        datasets: [
          {
            label: "Personas",
            data: [5, 6, 4.5, 7, 6.8],
            borderColor: "rgba(255, 159, 64, 1)", // Naranja
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            tension: 0.4,
            fill: true,
          },
        ],
      },
      chartOptions8: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
        },
      },

      // Gráfico 3: % de causas de ceses (Derecha)
      chartTitle9: "CAUSAS DE CESES",
      chartData9: {
        labels: [
          "Renuncia Voluntaria",
          "Despido por bajo desempeño",
          "Jubilacion",
          "Cese por fin de contrato ",
        ],
        datasets: [
          {
            label: "Personas %",
            backgroundColor: [
              "rgba(75, 192, 192, 0.6)", // Verde
              "rgba(255, 99, 132, 0.6)", // Rojo
              "rgba(255, 206, 86, 0.6)", // Amarillo
              "rgba(54, 162, 235, 0.6)", // Azul´
            ],
            data: [50, 20, 10, 20],
          },
        ],
      },
      chartOptions9: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true },
        },
      },
    };
  },
  created() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.plataformaEscogida = localStorage.getItem("catPlataforma");

    // Cargar datos de usuario para Ticka desde localStorage
    // Asegúrate de que estas claves existan en tu localStorage o ajusta los valores por defecto
    
    this.tickaUserName = localStorage.getItem("usuCodigo"); // Ejemplo de username
    this.tickaContrasena = localStorage.getItem("usuContrasena"); // Ejemplo de nombre completo

    this.cambiarEstadoNavbar();
    this.getAttributes();
    this.PlataformaCategoria();
    this.grafico1();
    this.grafico2();
    this.grafico3();
    this.grafico4();

    // Si la plataforma escogida es la 12 (Tickets), realizamos la sincronización
    if (this.plataformaEscogida === "12") {
      this.performTickaSync();
    }
  },

  computed: {
    tickaIframeSrc() {
      if (this.plataformaEscogida === "12") {
        return this.ssoTickaUrl || ""; // El iframe se cargará solo cuando ssoTickaUrl tenga valor
      }
      return "";
    },

        ...mapGetters("users", ["Correo","NombreTicka"]),

  },

  beforeDestroy() {
    // Limpiamos el temporizador si el usuario sale de la vista antes de la redirección
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },

  methods: {
    ...mapActions("acciones", ["PlataformaCategoria"]),
    ...mapActions("users", ["getAttributes"]),

    regresarDashboard() {
      this.$router.push("/dashboard");
    },

    cambiarEstadoNavbar() {
      if (this.plataformaEscogida == "12") {
        this.$store.dispatch("acciones/CambioNavbar", false);
      } else {
        this.$store.dispatch("acciones/CambioNavbar", true);
      }
    },

    handleRedirect() {
      // Detener el contador tanto si el clic fue manual como automático
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.openTickaInNewWindow();
      this.regresarDashboard();
    },

    openTickaInNewWindow() {
      // Abre Ticka en una nueva pestaña del navegador
      window.open(this.ssoTickaUrl, "_blank");
    },

    async performTickaSync() {
      this.ssoTickaUrl = ""; // Resetear URL al iniciar
      console.log("Iniciando proceso de integración con Ticka...");

      const userEmail = this.Correo;
      const userName = this.tickaUserName;
      const fullName = this.NombreTicka;
      const actions = ["CREAR", "CREAR_ACTUALIZAR", "ACTUALIZAR", "DESHABILITAR", "PASSWORD"];
      const password = "12345678";
      try {
        let allSyncSuccess = true;

        // Paso 1: Ciclar las acciones de sincronización
        for (const action of actions) {
          console.log(`Ejecutando sincronización: ${action}...`);
          const syncResponse = await this.axios.post(this.tickaSyncApiUrl, {
            accion: action,
            email: userEmail,
            username: userName,
            name: fullName,
            password: password,
            idUsuario : localStorage.getItem("userId"), // Asegúrate de que esta clave exista en tu localStorage
          });

          console.log(`Respuesta sync (${action}):`, syncResponse.data);

          if (!syncResponse.data.success) {
            console.error(`La acción ${action} falló. Deteniendo proceso.`);
            allSyncSuccess = false;
            break; // Detenemos el ciclo si una falla
          }
        }

        // Paso 2: Si todas fueron exitosas, obtener el link SSO
        if (allSyncSuccess) {
          console.log("Sincronización completa. Solicitando link de SSO...");
          const ssoResponse = await this.axios.post(this.tickaSsoLinkApiUrl, {
            email: userEmail,
          });

          if (ssoResponse.data.success && ssoResponse.data.url) {
            this.ssoTickaUrl = ssoResponse.data.url;
            console.log("URL de SSO obtenida con éxito.");

            // Iniciamos el temporizador de 3 segundos para redirección automática
            this.countdown = 3;
            this.countdownTimer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                this.handleRedirect();
              }
            }, 1000);
          } else {
            console.error("Error al obtener el link de SSO:", ssoResponse.data.mensaje);
          }
        }
      } catch (error) {
        console.error("Error en el flujo de integración:", error);
       }
    },
    grafico1() {
      this.axios
        .get("Dasboards/DashCantidadxPlanilla?a%C3%B1o=2024")
        .then((response) => {
          console.log("respuesta de la api de planilla ", response.data);
          if (this.chartData1.datasets.length > 0) {
            const objetoMes = response.data[0] || {};
            this.chartData1.labels = Object.keys(objetoMes);
            this.chartData1.datasets[0].data = Object.values(objetoMes);
            this.loadChartData1 = true;
          }
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        });
    },
    grafico2() {
      this.axios
        .get("Dasboards/DashCantidadxDepa")
        .then((response) => {
          console.log("respuesta de la api departamento ", response.data);
          const labels = response.data.map((item) => item.departamento);
          const datos = response.data.map((item) => item.cantidad);

          this.$set(this.chartData2, "labels", labels);
          this.$set(this.chartData2.datasets[0], "data", datos);
          this.loadChartData2 = true;
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        });
    },
    grafico3() {
      this.axios
        .get("Dasboards/DashCantidadxTipDocumento")
        .then((response) => {
          console.log("respuesta de la api documento ", response.data);

          const labels = response.data.map((item) => item.tipDocumento);
          const datos = response.data.map((item) => item.cantidad);

          this.$set(this.chartData3, "labels", labels);
          this.$set(this.chartData3.datasets[0], "data", datos);
          this.loadChartData3 = true;
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        });
    },
    grafico4() {
      this.axios
        .get("Dasboards/DashCantidadxRenynoRen?a%C3%B1o=2024&mes=01")
        .then((response) => {
          console.log("respuesta de la api renovados", response.data);

          let renovados = 0;
          let noRenovados = 0;

          // Buscar dentro del array qué valor es renovado y cuál no
          response.data.forEach((item) => {
            if (item.renovados !== undefined) {
              renovados = item.renovados;
            }
            if (item.noRenovados !== undefined) {
              noRenovados = item.noRenovados;
            }
          });

          // Cargar en el gráfico
          this.chartData4.labels = ["Renovados", "No Renovados"];
          this.chartData4.datasets[0].data = [renovados, noRenovados];

          this.loadChartData4 = true;
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        });
    },
  },
};
</script>

<style scoped>
/* Contenedores del título */
.titulo-container,
.contenedor {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  padding: 20px 0;
}

/* Estilo de los títulos */
.indicadores-titulo,
.indicadores {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

/* Contenedor de gráficos - PRIMERA FILA */
.graficos-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  /* Distribuir gráficos de izquierda a derecha */
  width: 100%;
  padding: 0 20px;
}

/* Contenedor de gráficos - SEGUNDA FILA (de derecha a izquierda) */
.grafico-linea-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  /* Distribuir gráficos de derecha a izquierda */
  flex-direction: row-reverse;
  /* Invertir el orden para alinear de derecha a izquierda */
  width: 100%;
  padding: 0 20px;
}

/* Contenedor individual de gráficos */
.grafico-container,
.grafico-container-linea {
  flex: 1;
  min-width: 200px;
  max-width: 600px;
  margin: auto;
  text-align: center;
  padding-bottom: 25px;
  padding-top: 25px;
}

/* Ajustes de la fila */
.row {
  padding: 0 !important;
  margin: 0 !important;
}

/* Estilos de los gráficos */
.small-Bar-container,
.line-chart-container,
.stacked-bar-container {
  width: 100%;
  max-width: 600px;
  /* Reducir el ancho */
  min-height: 400px;
  /* Aumentar el alto */
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Estilo del título de los gráficos */
.titulo-grafico {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

/* Media query para dispositivos móviles */
@media (max-width: 768px) {

  .graficos-wrapper,
  .grafico-linea-wrapper {
    flex-direction: column;
    /* Apilar gráficos en móviles */
    align-items: center;
    padding-left: 0;
  }

  .grafico-container,
  .grafico-container-linea {
    width: 100%;
    /* Que ocupen todo el ancho disponible */
    max-width: 400px;
    /* Evitar que sean demasiado grandes */
  }
}

.wide-Bar-container {
  height: 400px;
  width: 500px;
}

.mall-Bar-container {
  height: 400px;
  width: 100%;
  max-width: 400px;
}

.sll-Bar-container {
  height: 400px;
  width: 100%;
  max-width: 400px;
}

.tall-Bar-container {
  height: 500px;
  width: 100%;
  max-width: 500px;
}

.Bar-container {
  height: 500px;
  width: 100%;
  max-width: 400px;
}

.titulo-grafico {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 8px;
  display: block;
}

/* Animación de aparición */
.fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 1s ease forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header-titulo {
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin: 20px;
  text-align: center;
}

.ticka-iframe-container {
  width: 100%;
  height: calc(100vh - 100px);
  /* Ajusta la altura según sea necesario, restando el espacio del header/footer */
}

.ticka-iframe {
  width: 100%;
  height: 100%;
}
</style>